import styled from "styled-components";

export const WalletBtn = styled.div`
  display:flex;
  gap:10px;
  flex-wrap: wrap; /* 允许换行 */
  > * {
    flex: 1;
  }
  @media (max-width: 768px) {
   > * {
      flex: 0 0 calc(50% - 5px); /* 每行两个按钮，减去gap的一半 */
    }
  }
`
export const FooterSwapper = styled.div`
  margin:10px auto;
  max-width:1600px;
  background-color:#fff;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  .bbbbb {
    div {
    }
  }
  @media (max-width: 768px) {
  }
`
export const FooterTotal = styled.div`
  display: flex;
  justify-content: space-between; /* 卡片之间留出间距 */
  gap: 16px; /* 卡片之间的间距 */
  margin: 20px 0;

  .item {
    flex: 1; /* 每个卡片平分宽度 */
    border: 1px solid rgb(188, 235, 245); /* 边框颜色 */
    border-radius: 12px; /* 圆角 */
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0; /* 防止内容溢出 */
  }

  /* 第一行：标题和按钮 */
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    width: 100%;

    .label {
      color: #8F96AC; /* 灰色字体 */
      font-size: 14px;
      font-weight: 400;
    }
  }

  /* 按钮组容器 */
  .action-buttons {
    display: flex;
    gap: 8px; /* 按钮之间的间距 */
  }

  /* 按钮通用样式 */
  .btn {
    cursor: pointer;
    border-radius: 4px; /* 按钮小圆角 */
    padding: 4px 8px;
    font-size: 10px !important;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  /* 归集按钮 - 蓝色系 */
  .btn-collect {
    background-color: rgba(31, 100, 255, 0.15); 
    color: rgb(96 165 250); /* 蓝色文字 */
  }

  /* 转账按钮 - 绿色系 */
  .btn-transfer {
    background-color:rgb(16 185 129 / 0.2);
    color: rgb(52 211 153 );
  }

  /* 第二行：数值样式 */
  .value-row {
    font-size:  18px !important;
    font-weight: 700; /* 加粗 */
    line-height: 1.2;
    text-align:left;
    color:#666;
    font-family: sans-serif; 
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    flex-direction: column; /* 手机上垂直排列 */
    gap: 12px;
    
    .item {
      width: 100%;
    }
  }
`;

export const FooterContent = styled.div`
  display: flex;
  justify-content: space-around;
  max-height:300px;
  overflow-y:scroll;
   @media (max-width: 768px) {
   overflow-x: scroll;
   }
`
export const FooterItem = styled.div`
  flex:1;
  // min-width: 15%;
  // margin: 10px auto;
  // border-right: 1px solid #1fc7d4;
  text-align: center;
 10px;
  }

  @media (max-width: 768px) {
    // overflow: scroll;
    min-width: 30%;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const ItemHeader = styled.div`
  padding: 1rem 0;
  // border-top: 1px solid #1fc5d2;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Item = styled.div`
  margin-bottom: .5rem;
  display:flex;
  justify-content:center;
  align-items:center;
  height:38px;
  color:#666 !important;
`
export const ButtonSwapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
`